<template>
  <div></div>
</template>

<script>
import Swal from 'sweetalert2'

export default {
  name: 'ModalDelete',
  async mounted () {
    try {
      const res = await Swal({
        title: 'Confirmação de exclusão',
        text: 'Você confirma a exclusão do(s) registro(s) selecionado(s)?',
        type: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Sim, exclua!!',
        cancelButtonText: 'Não, mantenha'
      })

      this.$emit('callback', res)
    } catch (e) {
      console.error(e)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/modal/ModalDelete.vue